import {
  SET_AUTO_DOCUMENTS,
  RESET_INITIAL_AUTO_STATE,
  SET_WITNESS_OBJ,
  SET_INJURED_OBJ,
  SET_PASSENGER_OBJ
} from "../actions/anonAutoForm";

const initialState = {
  documents: { files: [], size: 0 },
  witnessObj: null,
  injuredObj: null,
  passengerObj: null
};

export const anonAutoFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_WITNESS_OBJ:
      return {...state, witnessObj: action.obj };
    case SET_INJURED_OBJ:
      return {...state, injuredObj: action.obj };
    case SET_PASSENGER_OBJ:
      return {...state, passengerObj: action.obj};
    case SET_AUTO_DOCUMENTS:
      return { ...state, documents: action.documents };
    case RESET_INITIAL_AUTO_STATE:
      return { ...initialState };
    default:
      return { ...state };
  }
};
